/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import style from './StoreBadge.module.less';

import steamWishlist from './assets/Wishlist on Steam.png';
import steamBuy from './assets/Download on Steam.png';
import appStoreBuy from './assets/Download on App Store.png';
import googlePlayBuy from './assets/Download on Google Play.png';

type BadgeTypes = 'Steam Wishlist' | 'Steam Download' | 'App Store Download' | 'Google Play Download';

type Props = {
  title: string;
  link: string;
  type: BadgeTypes;
};

const getImage = (type: BadgeTypes) => {
  if (type === 'Steam Wishlist') {
    return steamWishlist;
  }
  if (type === 'Steam Download') {
    return steamBuy;
  }
  if (type === 'App Store Download') {
    return appStoreBuy;
  }
  if (type === 'Google Play Download') {
    return googlePlayBuy;
  }
  return steamWishlist;
};

export const StoreBadge = ({ title, type, link }: Props) => (
  <a className={style.link} href={link} target="_blank">
    <img className={style.image} src={getImage(type)} alt={title} />
  </a>
);
